<template>
  <theme-provider :theme="theme">
    <div v-if="isLoading" />
    <div v-if="!isLoading">
      <div v-if="$route.meta.layout === 'page'">
        <app-header :logoUrl="theme.logoUrl" />
        <div class="app">
          <router-view />
        </div>
      </div>
      <div class="app" v-if="$route.meta.layout === 'plain'">
        <router-view />
      </div>
      <app-footer :imprintLink="footerLinks.imprintLink" :privacyLink="footerLinks.privacyLink" />
    </div>
    <cookie-consent />
  </theme-provider>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { ThemeProvider } from 'vue-styled-components';
import AppHeader from '@/components/global/header.vue';
import AppFooter from '@/components/global/footer.vue';
import CookieConsent from '@/components/cookieConsent.vue';

export default {
  name: 'App',

  components: {
    AppHeader,
    ThemeProvider,
    AppFooter,
    CookieConsent,
  },

  computed: {
    ...mapGetters({
      // mainMenu: 'general/getMainMenu',
      footerLinks: 'general/getFooterLinks',
      theme: 'general/getTheme',
    }),
  },

  data() {
    return {
      isLoading: true,
    };
  },

  async mounted() {
    // this.isLoading = true;
    // await this.fetchMainMenu();
    this.isLoading = false;
  },

  methods: {
    ...mapActions('general', {
      // fetchMainMenu: 'fetchMainMenu',
    }),
  },
};
</script>
